var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-layout',[_c('div',{staticClass:"applications-page"},[_c('h3',[_vm._v("Applications")]),_c('div',{staticClass:"applications-page__content"},[_c('aplications-list')],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }